import { formatPesoAmount } from '../../utils/money';
import { formatPromotionTerms } from '../../utils/priceListPromotions';
import { activeTemporaryPrices, resolveTemporaryUnitPrice } from '../../utils/temporaryPriceCore';

export const displayItemKey = (item) => String(item?.varietyPriceId ?? '');

export const displayProductsPerSlide = (value) => [4, 5, 6].includes(Number(value)) ? Number(value) : 4;

export const displaySlides = (items = [], productsPerSlide = 4) => {
  const size = displayProductsPerSlide(productsPerSlide);
  const slides = [];
  const seen = new Set();
  items.forEach((item) => {
    const key = displayItemKey(item);
    if (seen.has(key)) return;
    seen.add(key);
    if (!slides.length || slides[slides.length - 1].length === size) slides.push([]);
    slides[slides.length - 1].push(item);
  });
  return slides;
};

export const displaySlideIndex = (slides, activeId) => Math.max(
  slides.findIndex((slide) => slide.some((item) => displayItemKey(item) === String(activeId))), 0,
);

export const displayPrice = (item, now, showPromotions = true) => {
  const records = (showPromotions ? item.promotions || [] : []).filter((promotion) => (
    Number(promotion.varietyPriceId) === Number(item.varietyPriceId)
  ));
  const { effectivePrice, unitPrice } = resolveTemporaryUnitPrice(Number(item.regularPrice), records, now);
  return {
    effectivePrice,
    unitPrice,
    packs: activeTemporaryPrices(records, now)
      .filter((promotion) => ['pack', 'weight_threshold'].includes(promotion.type))
      .sort((a, b) => a.quantity - b.quantity || a.promotionPrice - b.promotionPrice),
  };
};

export const formatDisplayPrice = (value) => `$${formatPesoAmount(value)}`;

export const displayPromotionLabels = (item, now, showPromotions = true) => {
  const price = displayPrice(item, now, showPromotions);
  return [
    ...(price.unitPrice ? [price.effectivePrice < Number(item.regularPrice)
      ? `Descuento de ${formatDisplayPrice(Number(item.regularPrice) - price.effectivePrice)}`
      : 'Precio de oferta'] : []),
    ...price.packs.map((pack) => `Por cantidad: ${formatPromotionTerms(pack)}`),
  ];
};

export const displaySellingUnit = (item) => {
  const unit = String(item.metricUnit || '').trim();
  const normalized = unit.toLowerCase();
  if (['kg', 'kilo', 'kilos', 'kilogramo', 'kilogramos'].includes(normalized)) return 'por kilo';
  if (['un', 'u', 'und', 'unidad', 'unidades'].includes(normalized)) return 'por unidad';
  if (['pack', 'paquete'].includes(normalized)) return 'por pack';
  return unit ? `por ${unit}` : `por ${item.formatLabel || 'unidad'}`;
};
